import { useState } from 'react';
import normalImg from '@arelia-assets/google-signin-button/btn_google_signin_dark_normal_web.png';
import focusImg from '@arelia-assets/google-signin-button/btn_google_signin_dark_focus_web.png';
import pressedImg from '@arelia-assets/google-signin-button/btn_google_signin_dark_pressed_web.png';

export function GoogleSigninButton({ clicked }: {clicked: () => void}) {
  const [buttonState, setButtonState] = useState('normal');

  return (
    <img
      onClick={clicked}
      style={{ cursor: 'pointer' }}
      src={
        buttonState === 'normal'
          ? normalImg
          : buttonState === 'focus'
            ? focusImg
            : pressedImg
      }
      alt="Google Sign-In"
      onMouseOver={() => setButtonState('focus')}
      onMouseOut={() => setButtonState('normal')}
      onMouseDown={() => setButtonState('pressed')}
      onMouseUp={() => setButtonState('focus')}
    />
  );
}